<template>
  <CustomSelect
    class="w-100"
    inputId="userStatusPicker"
    inputLabel="وضعیت کاربر"
    v-model="modelValue"
    :customOptions="statusList"
  ></CustomSelect>
</template>
<script>
export default {
  emits: ["getSelectedStatus"],
  props: {
    defaultSelectedStatus: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedStatus) {
      this.selectedStatus = this.defaultSelectedStatus;
    }
  },
  data() {
    return {
      statusList: [
        {
          text: "فعال",
          value: 1,
        },
        {
          text: "غیر فعال",
          value: 0,
        },
      ],
      selectedStatus: null,
    };
  },

  computed: {
    modelValue: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },

  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
